import script from "./MobileStickyDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileStickyDescription.vue?vue&type=script&setup=true&lang=js"

import "./MobileStickyDescription.vue?vue&type=style&index=0&id=cedcaeb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cedcaeb4"]])

export default __exports__